<template>
   <div class="dialog draggable-item bg-light light w-100-sm w-100-md w-75-lg w-50-xl h-75">
      <div class="dialog-title pl-10">{{ $t("Configure restore from a backup job") }}</div>
      <div class="dialog-content p-0">
         <div class="form-group h-100">
            <div v-if="loading" class="d-flex flex-justify-center p-10">
               <span class="mif-spinner2 fg-primary mif-3x ani-spin" />
            </div>
            <div v-else class="h-100">
            	<label class="text-bold">{{ $t("Select backup job to restore") }}</label>
				<!--FILTRI-->
               <div class="row mb-2">
                  <div>
                     <select class="select text-small w-auto px-2" v-model="backupJobs_filters.sourceType">
                        <option :value="-1">{{ $t("Source") }}</option>
                        <optgroup v-for="(types, category) in backupJobs_filters.sourceTypesList" :label="$t(category)" v-once>
                           <option v-for="type in types" :key="type" :value="type"> {{ $ONEServiceTypeInfo['' + type].name }}</option>
                        </optgroup>
                     </select>
                  </div>
                  <div class="ml-4">
                     <select class="select text-small w-auto px-2" v-model="backupJobs_filters.destinationType">
                        <option :value="-1">{{ $t("Destination") }}</option>
                        <optgroup v-for="(types, category) in backupJobs_filters.destinationTypesList" :label="$t(category)" v-once>
                           <option v-for="type in types" :key="type" :value="type"> {{ $ONEServiceTypeInfo['' + type].name }}</option>
                        </optgroup>
                     </select>
                  </div>
				  <div class="ml-auto">
            			<input v-model="includeDeletedJobs" type="checkbox" data-role="checkbox" :data-caption="$t('Include deleted backup jobs')" @change="getAPIJobs">
				  </div>
               </div>

				<!--TABELLA-->
				<div class="h-90 overflow">
					<table id="backup-list" class="overflow bg-white border table table-sm striped compact p-2">
						<thead class="mb-0">
							<tr class="mb-3">
								<th class="text-center no-wrap" style="vertical-align: middle;"></th>
								<th class="text-left pl-4" style="vertical-align: middle;">{{ $t("Backup name") }}</th>
								<th style="vertical-align: middle;width: 50px;">{{ $t("Source Type") }}</th>
								<th style="vertical-align: middle;width: 50px;">{{ $t("Destination Type") }}</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="(job, id) in jobs">
								<tr v-show="[-1, parseInt(job.type)].includes(backupJobs_filters.sourceType) && [-1, job.destinations[0].type].includes(backupJobs_filters.destinationType)"
								:disabled="job.last_result == $ResultValue.Running || job.type == $ONEServiceType.DriveImage">
								<td class="text-center">
									<input v-model="selectedJob" :value="job" name='apiJobs' type='radio' data-role='radio'>
								</td>
								<td class="d-flex flex-column">
									<label class="text-bold">{{ job.name }}</label>
									<span v-if="job.status == -1" class='fg-red'>({{ $t("Deleted") }})</span>
									<span v-if="job.last_result == $ResultValue.Running" class='fg-darkGray'>({{ $t("Backup in progress") }})</span>
									<span v-if="job.type == $ONEServiceType.DriveImage" class="fg-darkGray">({{ $t("Can only be restored via USB recovery stick") }})</span>
								</td>
								<td>
									<span class='badge inline tertiary'>{{ $ONEServiceTypeInfo[job.type].name.toUpperCase() }}</span>
								</td>
								<td>
									<span class='badge inline tertiary '>{{ $ONEServiceTypeInfo[job.destinations[0].type].name.toUpperCase() }}</span>
								</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
            </div>
         </div>
      </div>
      <div class="dialog-actions">
         <button class="button secondary my-3" @click="$root.$emit('configureRestoreJob', selectedJob)" :disabled="selectedJob == null">{{ $t("Configure restore") }}</button>
         <button class="button js-dialog-close" @click="$root.$emit('CLOSECONFRESTOREFROMBACKUPJOB')">{{ $t("Close") }}</button>
      </div>
   </div>
</template>
<script>
import { getMapWithCategoriesAndPlatformTypes } from '../../../utils/utilitiesmodule';

export default {
	name: "ConfRestoreFromBackupJob",
	props: {
		idPC: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			selectedJob: null,
			jobs: [],
			includeDeletedJobs: false,
			loading: false,

			backupJobs_filters: {
                sourceTypesList: getMapWithCategoriesAndPlatformTypes("forBackupSource", true),
                sourceType: -1,
                destinationTypesList: getMapWithCategoriesAndPlatformTypes("forBackupDestination", true),
                destinationType: -1
			}
		}
	},

	created() {
		this.getAPIJobs();
	},

	methods: {

		getAPIJobs() {
			this.loading=true;
			this.jobs.clear();
			this.$api.getBackupJobsForRestore(this.idPC, this.includeDeletedJobs? 1:0).then(list => {
				this.jobs.push(...list);
				this.loading=false;
			});
		}

	}
}
</script>